<h1 mat-dialog-title>Proceed Confirmation!</h1>
<div mat-dialog-content>
  <p>Are you sure you want to proceed <b>{{proceedText}}?</b></p>
  <p>To proceed, enter the phrase <b>{{confirmationText}}</b></p>
  <mat-form-field subscriptSizing="dynamic" provideReadonly style="width: 100%">
    <mat-label>Confirmation text</mat-label>
    <input matInput [placeholder]="confirmationText" [formControl]="confirmationFormControl"
           (keydown.enter)="confirm()">
  </mat-form-field>
</div>
<div mat-dialog-actions style="justify-content: flex-end;">
  <button mat-flat-button (click)="cancel()">CANCEL</button>
  <button mat-flat-button (click)="confirm()" color="warn" [disabled]="!confirmationFormControl.valid">PROCEED
  </button>
</div>

